module.exports = __webpack_public_path__ + "img/skull1.601c0f4a.png";